<div class="container-fluid pb-4">
  <h4>
    <span *ngIf="incarico; else creating">
      Modifica Incarico {{ incarico.humanIdentifier }}
      <img
        style="height: 50px; padding-left: 10px"
        *ngIf="this.incarico?.polizza?.compagnia?.logo_path"
        src="{{ this.incarico?.polizza?.compagnia?.logo_path }}"
      />
    </span>
  </h4>
  <ng-template #creating>Inserimento Incarico</ng-template>

  <form class="row" *ngIf="form && !loading; else loader" [formGroup]="form">
    <div class="row no-gutters form-fields-wrapper">
      <mat-form-field>
        <mat-label>Stato</mat-label>
        <stato-incarico-picker formControlName="stato"></stato-incarico-picker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Inseritore</mat-label>
        <user-picker formControlName="inseritore"></user-picker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Accertatore</mat-label>
        <user-picker
          [defaultSearch]="{ ruoli: [14], studio: form?.value?.studio }"
          formControlName="accertatore"
        >
        </user-picker>
        <div
          matSuffix
          *ngIf="getAccertatoreModifiedAtLabel() as accLabel"
          class="text-muted accertatore-modified-info accertatore-modified-info--desktop"
        >
          {{ accLabel }}
        </div>
      </mat-form-field>
      <div
        *ngIf="getAccertatoreModifiedAtLabel() as accLabel"
        class="text-muted accertatore-modified-info accertatore-modified-info--mobile"
      >
        {{ accLabel }}
      </div>
      <mat-form-field>
        <mat-label>Incaricato</mat-label>
        <user-picker
          [defaultSearch]="{ ruoli: [15], studio: form?.value?.studio }"
          [preferenceHints]="incaricatoPreferenceHints"
          formControlName="incaricato"
        >
        </user-picker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Firmatario</mat-label>
        <user-picker
          [defaultSearch]="{ ruoli: [17], studio: form?.value?.studio }"
          formControlName="firmatario"
        >
        </user-picker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Auditor</mat-label>
        <user-picker
          [defaultSearch]="{ ruoli: [16], studio: form?.value?.studio }"
          formControlName="auditor"
        ></user-picker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Evasore</mat-label>
        <user-picker formControlName="evasore"></user-picker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Liquidatore</mat-label>
        <liquidatore-picker
          formControlName="liquidatore"
          [allowExternalLink]="!!incarico"
        ></liquidatore-picker>
      </mat-form-field>

      <div class="row col-12 no-gutters">
        <mat-form-field class="col pr-1">
          <mat-label>Data Sinistro</mat-label>
          <date-picker matInput formControlName="data_sinistro"></date-picker>
        </mat-form-field>
        <mat-form-field class="col pr-1">
          <mat-label>Data Denuncia</mat-label>
          <date-picker formControlName="data_denuncia"></date-picker>
        </mat-form-field>
        <mat-form-field class="col pr-1">
          <mat-label>Data Incarico</mat-label>
          <date-picker formControlName="data"></date-picker>
        </mat-form-field>
      </div>

      <mat-form-field>
        <mat-label>Numero Sinistro</mat-label>
        <input matInput formControlName="numero_sinistro" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Polizza</mat-label>
        <polizza-picker
          [allowExternalLink]="!!incarico"
          formControlName="polizza"
          [incarico]="incarico"
        ></polizza-picker>
      </mat-form-field>
      <ng-container [formGroup]="readOnlyForm" *ngIf="readOnlyForm">
        <mat-form-field *ngIf="incarico?.polizza?.agenzia">
          <mat-label>Agenzia</mat-label>
          <agenzia-picker
            [readonly]="true"
            [allowExternalLink]="!!incarico"
            formControlName="agenzia"
          >
          </agenzia-picker>
        </mat-form-field>
        <ng-container *ngIf="getCurrentContraenteType() as contraenteType">
          <mat-form-field
            *ngIf="contraenteType === 'altroSoggetto'"
            class="contraente-field"
          >
            <mat-label>Contraente</mat-label>
            <altro-soggetto-picker
              [readonly]="true"
              [allowExternalLink]="!!incarico"
              formControlName="contraente"
            >
            </altro-soggetto-picker>
          </mat-form-field>

          <mat-form-field
            *ngIf="contraenteType === 'fabbricato'"
            class="contraente-field"
          >
            <mat-label>Contraente</mat-label>
            <fabbricato-picker
              [readonly]="true"
              [allowExternalLink]="!!incarico"
              formControlName="contraente"
            >
            </fabbricato-picker>
          </mat-form-field>

          <ng-container
            *ngIf="getContraenteMissingFields() as contraenteMissingFields"
          >
            <div
              *ngIf="contraenteMissingFields.length"
              class="text-danger contraente-warning"
            >
              Attenzione: dati contraente incompleti. Mancano
              {{ contraenteMissingFields.join(", ") }}.
            </div>
          </ng-container>
        </ng-container>
        <mat-form-field *ngIf="readOnlyForm.value.amministratore">
          <mat-label>Amministratore</mat-label>
          <altro-soggetto-picker
            [readonly]="true"
            [allowExternalLink]="!!incarico"
            formControlName="amministratore"
          >
          </altro-soggetto-picker>
        </mat-form-field>
      </ng-container>

      <div class="row col-12 no-gutters">
        <mat-form-field class="col pr-1">
          <mat-label>Tipo di Danno</mat-label>
          <tipo-danno-picker formControlName="tipo_danno"></tipo-danno-picker>
        </mat-form-field>
        <mat-form-field class="col">
          <mat-label>Ramo</mat-label>
          <ramo-picker formControlName="ramo"></ramo-picker>
        </mat-form-field>
      </div>

      <mat-form-field>
        <mat-label>Ispettorato</mat-label>
        <ispettorato-picker
          formControlName="ispettorato"
          [defaultSearch]="{ compagnia: form?.value?.polizza?.compagnia_id }"
        >
        </ispettorato-picker>
      </mat-form-field>
    </div>

    <div class="row no-gutters form-fields-wrapper">
      <div class="contatto-fields-row">
        <mat-form-field class="contatto-field pr-1">
          <mat-label>Data 1° Contatto</mat-label>
          <date-picker formControlName="data_primo_contatto"></date-picker>
        </mat-form-field>
        <mat-form-field class="contatto-field pr-1">
          <mat-label>Data Sopralluogo Fissata</mat-label>
          <date-picker
            formControlName="data_sopralluogo_fissata_data"
          ></date-picker>
        </mat-form-field>
        <mat-form-field class="contatto-field pr-1">
          <mat-label>Ora Sopralluogo Fissata</mat-label>
          <input
            matInput
            type="text"
            formControlName="data_sopralluogo_fissata_ora"
            class="no-placeholder"
            placeholder="Es. 09:00 o 09:00 - 10:00"
            (blur)="onTimeFieldBlur('data_sopralluogo_fissata_ora')"
          />
        </mat-form-field>
        <mat-form-field
          class="contatto-field pr-1"
          [matTooltip]="dataSopralluogoDisabledReason || ''"
          [matTooltipDisabled]="!dataSopralluogoDisabledReason"
          [matTooltipClass]="'tight-tooltip'"
        >
          <mat-label>Data Sopralluogo</mat-label>
          <date-picker formControlName="data_sopralluogo"></date-picker>
        </mat-form-field>
        <mat-form-field class="contatto-field">
          <mat-label>Data 2° Sopralluogo</mat-label>
          <date-picker formControlName="data_secondo_sopralluogo"></date-picker>
        </mat-form-field>
      </div>
      <div class="row col-12 no-gutters">
        <mat-form-field class="col pr-1">
          <mat-label>1a Interlocutoria</mat-label>
          <date-picker
            formControlName="prima_interlocutoria"
            (dateChange)="
              checkRiservaOnDateChange('prima_interlocutoria', $event)
            "
          ></date-picker>
        </mat-form-field>
        <mat-form-field class="col pr-1">
          <mat-label>2a Interlocutoria</mat-label>
          <date-picker
            formControlName="seconda_interlocutoria"
            (dateChange)="
              checkRiservaOnDateChange('seconda_interlocutoria', $event)
            "
          ></date-picker>
        </mat-form-field>
        <mat-form-field class="col">
          <mat-label>Ultima Interlocutoria</mat-label>
          <date-picker
            formControlName="terza_interlocutoria"
            (dateChange)="
              checkRiservaOnDateChange('terza_interlocutoria', $event)
            "
          ></date-picker>
        </mat-form-field>
      </div>
      <div class="col-12 row mb-3">
        <div class="col-4 col">
          <div class="d-flex flex-column">
            <div class="mat-form-field">
              <mat-slide-toggle formControlName="pronta_liquidazione"
                >Pronta Liquidazione</mat-slide-toggle
              >
            </div>

            <div class="mat-form-field">
              <mat-slide-toggle formControlName="globale_fabbricati"
                >Globale Fabbricati</mat-slide-toggle
              >
            </div>

            <div class="mat-form-field">
              <mat-slide-toggle
                formControlName="documento_contabile_opere_ripristino"
                >Doc. Contabile Opere di Ripristino</mat-slide-toggle
              >
            </div>
          </div>
        </div>

        <div class="col-4 col pr-0">
          <div class="d-flex flex-column">
            <div class="mat-form-field">
              <mat-slide-toggle formControlName="riserva"
                >Riserva</mat-slide-toggle
              >
            </div>

            <div class="mat-form-field">
              <mat-slide-toggle formControlName="foto_attestati_danno"
                >Foto Danno</mat-slide-toggle
              >
            </div>

            <div class="mat-form-field">
              <mat-slide-toggle
                formControlName="sollecitato"
                [disabled]="!hasAmministrativo"
                >Sollecitato</mat-slide-toggle
              >
            </div>
          </div>
        </div>

        <div class="col-4 col pl-0">
          <div class="d-flex flex-column">
            <div class="mat-form-field">
              <mat-slide-toggle formControlName="over_10000"
                >Sinistro Over 10.000</mat-slide-toggle
              >
            </div>

            <div class="mat-form-field">
              <mat-slide-toggle formControlName="over_50000"
                >Sinistro Over 50.000</mat-slide-toggle
              >
            </div>

            <div class="mat-form-field">
              <mat-slide-toggle
                formControlName="inviare_atto"
                [disabled]="
                  form?.value?.data_invio_atto || currentlyWorkingWith[110]
                "
              >
                Atto da Inviare
              </mat-slide-toggle>
            </div>

          </div>
        </div>
      </div>
      <!-- Sollecito Documentazione + Data Invio Atto -->
      <div class="row col-12 no-gutters justify-content-between">
        <mat-form-field class="col-4">
          <mat-label>Sollecito Documentazione</mat-label>
          <date-picker formControlName="data_sollecito_documentazione"></date-picker>
          <div
            matSuffix
            *ngIf="
              form?.value?.data_sollecito_documentazione ||
              incarico?.data_sollecito_documentazione ||
              incarico?.date_sollecito_documentazione_count != null
            "
            class="date-invio-atto-info text-muted"
          >
            <button
              type="button"
              class="date-invio-atto-counter text-primary"
              [disabled]="!incarico?.id"
              (click)="openDateSollecitoDocumentazioneHistory($event)"
            >
              ({{ incarico?.date_sollecito_documentazione_count || 0 }})
            </button>
            <b>[{{ getUltimaModificaSollecitoDocumentazioneFromForm() }}gg]</b>
          </div>
          <mat-slide-toggle
            matSuffix
            class="data-invio-atto-toggle ml-1"
            [checked]="!!form?.value?.data_sollecito_documentazione"
            (change)="toggleSollecitoDocumentazione($event.checked)"
            (click)="$event.stopPropagation()"
            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
            disableRipple
          ></mat-slide-toggle>
        </mat-form-field>
        <mat-form-field class="col-4">
          <mat-label>Data Invio Atto</mat-label>
          <date-picker formControlName="data_invio_atto"></date-picker>
          <div
            matSuffix
            *ngIf="
              form?.value?.data_invio_atto ||
              incarico?.data_invio_atto ||
              incarico?.date_invio_atto_count != null
            "
            class="date-invio-atto-info text-muted"
          >
            <button
              type="button"
              class="date-invio-atto-counter text-primary"
              [disabled]="!incarico?.id"
              (click)="openDateInvioAttoHistory($event)"
            >
              ({{ incarico?.date_invio_atto_count || 0 }})
            </button>
            <b>[{{ getUltimaModificaInvioAttoFromForm() }}gg]</b>
          </div>
          <mat-slide-toggle
            matSuffix
            class="data-invio-atto-toggle ml-1"
            [checked]="!!form?.value?.data_invio_atto"
            (change)="toggleDataInvioAtto($event.checked)"
            (click)="$event.stopPropagation()"
            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
            disableRipple
          ></mat-slide-toggle>
        </mat-form-field>
      </div>

      <!-- Riserva di Danno, Importo Richiesto -->
      <div class="row col-12 no-gutters">
        <mat-form-field class="col-6 pr-1">
          <mat-label>Riserva di Danno</mat-label>
          <input
            type="text"
            matInput
            currencyFormat
            formControlName="riserva_di_danno_range"
            [required]="form?.value?.data_sopralluogo"
          />
          <mat-error> "Riserva di Danno" è richiesto </mat-error>
        </mat-form-field>
        <mat-form-field class="col-6">
          <mat-label>Importo Richiesto</mat-label>
          <input
            max="999999999999"
            type="number"
            min="0"
            matInput
            formControlName="importo_richiesto"
          />
        </mat-form-field>
      </div>

      <!-- Danno Accertato, Indennizzo, Supplementi, Spese Demolizione -->
      <div class="row col-12 no-gutters">
        <mat-form-field class="col-3 pr-1">
          <mat-label>Danno Accertato</mat-label>
          <input
            max="999999999999"
            type="number"
            min="0"
            matInput
            formControlName="danno_accertato"
          />
        </mat-form-field>
        <mat-form-field class="col-3 pr-1">
          <mat-label>Indennizzo / Risarcimento</mat-label>
          <input
            max="999999999999"
            type="number"
            min="0"
            matInput
            formControlName="indennizzo_risarcimento"
          />
        </mat-form-field>
        <mat-form-field class="col-3 pr-1">
          <mat-label>Supplementi di Indennizzo</mat-label>
          <input
            max="999999999999"
            type="number"
            min="0"
            matInput
            formControlName="supplementi_indennizzo"
          />
        </mat-form-field>
        <mat-form-field class="col-3">
          <mat-label>Spese Demolizione e Sgombero</mat-label>
          <input
            max="999999999999"
            type="number"
            min="0"
            matInput
            formControlName="spese_demolizione_sgombero"
          />
        </mat-form-field>

        <div class="col-12 row no-gutters">
          <div class="col pr-1">
            <mat-form-field>
              <mat-label>Data di Spedizione</mat-label>
              <date-picker formControlName="data_spedizione"></date-picker>
              <span
                matTooltip="Differenza tra data di spedizione e data incarico in giorni"
                *ngIf="getDurataIncarico() as durata"
                matSuffix
              >
                {{ durata }} g
              </span>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field>
              <mat-label>Data di Scadenza</mat-label>
              <date-picker formControlName="data_scadenza"></date-picker>
            </mat-form-field>
          </div>
        </div>

        <mat-form-field>
          <mat-label>Studio</mat-label>
          <studio-picker formControlName="studio"></studio-picker>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Broker</mat-label>
          <input matInput formControlName="broker" />
        </mat-form-field>
        <div class="row col-12 no-gutters">
          <mat-form-field class="col-9 pr-1">
            <mat-label>Via</mat-label>
            <input matInput formControlName="via" />
          </mat-form-field>
          <mat-form-field class="col-3">
            <mat-label>Civico</mat-label>
            <input matInput formControlName="civico" />
          </mat-form-field>
        </div>
        <div class="row col-12 no-gutters">
          <mat-form-field class="col-9 pr-1">
            <mat-label>Comune Danno</mat-label>
            <comune-picker formControlName="comune"></comune-picker>
          </mat-form-field>

          <mat-form-field class="col-3">
            <mat-label>CAP</mat-label>
            <input matInput formControlName="cap" />
          </mat-form-field>
        </div>

        <mat-form-field>
          <mat-label>Stato Videoperizia</mat-label>
          <stato-videoperizia-picker
            formControlName="stato_videoperizia"
          ></stato-videoperizia-picker>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Riparazione in Forma Specifica</mat-label>
          <stato-riparazione-picker
            formControlName="stato_riparazione"
          ></stato-riparazione-picker>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Note</mat-label>
          <textarea
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="5"
            matInput
            formControlName="note"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
  </form>
  <!-- Reorganized action layout -->
  <div class="form-actions">
    <div
      *ngIf="form && showConcordatoToggle"
      [formGroup]="form"
      class="form-actions__concordato"
    >
      <mat-slide-toggle formControlName="concordato">
        Concordato
      </mat-slide-toggle>
    </div>

    <div class="d-flex justify-content-between my-2">
      <div>
        <button
          mat-raised-button
          color="primary"
          class="mr-2"
          (click)="handleSuccessfulSubmit()"
        >
          Salva
        </button>
        <button
          *ngIf="
            deepPropertyEnabled &&
            incarico?.stato?.id != 5 &&
            incarico?.stato?.id != 8
          "
          mat-raised-button
          color="primary"
          (click)="showDeepPropertyPdf()"
        >
          Analizza indirizzo
        </button>
      </div>
      <div>
        <button
          *ngIf="
            !isInseritoDaPortale &&
            (incarico?.polizza?.contraente ||
              form?.value?.polizza?.original_model?.contraente) &&
            canCopyAddressFromPolizza
          "
          mat-raised-button
          color="primary"
          (click)="copyDataFromPolizza()"
          matTooltip="Riempi i dati riguardanti l'ubicazione del danno, recuperandoli dal contraente della polizza."
        >
          Copia Indirizzo dalla Polizza
        </button>
        <button
          mat-raised-button
          class="whatsapp-button ml-2"
          *ngIf="
            this.incarico?.polizza?.contraente?.cell ||
            this.incarico?.polizza?.contraente?.tel
          "
          (click)="
            updateIncaricoNote('Primo Contatto WhatsApp', true);
            sendWhatsappMessage()
          "
        >
          Primo Contatto
        </button>
      </div>
    </div>

    <!-- Row 2: Left / Right -->
    <div class="d-flex justify-content-between my-2">
      <div>
        <button
          class="ml-0 btn-evidenza"
          mat-raised-button
          [disabled]="currentlyWorkingWith[120]"
          (click)="
            updateIncaricoNote('Da Redigere ');
            addToWorkflowStep(120);
            removeWorkflowStep([90, 100, 110, 130])
          "
          *ngIf="incarico?.stato?.id != 5 && incarico?.stato?.id != 8"
        >
          Da Redigere
        </button>
        <a [href]="getMailAttesaDocumentazione()">
          <button
            class="ml-2 btn-evidenza"
            mat-raised-button
            [disabled]="currentlyWorkingWith[100]"
            (click)="
              updateIncaricoNote('Att. Doc. ');
              addToWorkflowStep(100);
              removeWorkflowStep([90])
            "
          >
            Attesa Documentazione
          </button>
        </a>
        <button
          class="ml-2 btn-sinistri"
          mat-raised-button
          (click)="addToWorkflowStep(150)"
        >
          Sinistro Problematico
        </button>
      </div>
      <div>
        <a [href]="getMailHref()">
          <button mat-raised-button color="primary">
            Email Oggetto Precompilato
          </button>
        </a>
        <a class="ml-2" *ngIf="canSeeAttesaDoc" [href]="getMailAttesaDoc()">
          <button
            mat-raised-button
            style="background-color: #ffb6c1; color: white"
            (click)="updateIncaricoNote('Att. Doc. '); addToWorkflowStep(100)"
          >
            Attesa Doc
          </button>
        </a>
        <a class="ml-2" *ngIf="canSeeAttesaDoc" [href]="getMailSollecito()">
          <button
            mat-raised-button
            style="background-color: #c80b2f; color: white"
            (click)="updateIncaricoSollecitato()"
          >
            Sollecito
          </button>
        </a>
      </div>
    </div>

    <div
      class="d-flex justify-content-between my-2"
      *ngIf="incarico?.stato?.id != 5 && incarico?.stato?.id != 8"
    >
      <div>
        <button
          *ngIf="incarico?.stato?.id != 13"
          [disabled]="loadingActions[13]"
          mat-raised-button
          color="primary"
          (click)="cambiaStato(13, 'Verifica preliminare')"
        >
          Verifica Preliminare
        </button>
        <button
          class="ml-2"
          *ngIf="incarico?.stato?.id != 10"
          [disabled]="loadingActions[10]"
          mat-raised-button
          color="primary"
          (click)="cambiaStato(10, 'Perizia da correggere')"
        >
          Perizia da Correggere
        </button>
        <button
          class="ml-2"
          *ngIf="incarico?.stato?.id != 11"
          [disabled]="loadingActions[11]"
          mat-raised-button
          color="primary"
          (click)="cambiaStato(11, 'Incarico da evadere')"
        >
          Incarico da Evadere
        </button>
      </div>
      <div>
        <button
          *ngIf="
            this.incarico?.stato?.id == 11 &&
            this.extension?.enabled &&
            this.externalExists
          "
          mat-raised-button
          color="primary"
          (click)="inviaIncarico()"
        >
          Invia a Compagnia
        </button>
      </div>
    </div>
  </div>

  <div class="my-2" *ngIf="form?.value?.polizza">
    <pregressi [polizza]="form.value.polizza"></pregressi>
  </div>

  <ng-template #loader>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>
